module.exports = __webpack_public_path__ + "static/media/5.375e6a1d.png";